import React, { useState } from "react";
import { Link } from "react-router-dom";

export function FashionFooter() {
  const [email, setEmail] = useState("");

  return (
    <footer className="bg-fashion-bg-dark text-white">
      {/* Newsletter */}
      <div className="fashion-section border-b border-fashion-border-dark">
        <div className="fashion-container text-center max-w-xl mx-auto">
          <h3 className="font-display text-display-sm font-light tracking-wide mb-3">
            Stay in the Edit
          </h3>
          <p className="text-sm text-white/50 mb-8">
            Be the first to know about new collections, exclusive offers, and seasonal edits.
          </p>
          <form
            onSubmit={(e) => { e.preventDefault(); setEmail(""); }}
            className="flex flex-col sm:flex-row gap-3"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="fashion-input flex-1"
              required
            />
            <button type="submit" className="btn-fashion btn-fashion-white whitespace-nowrap">
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Links */}
      <div className="fashion-section py-12 md:py-16">
        <div className="fashion-container">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Shop */}
            <div>
              <p className="text-overline text-white/40 mb-4">Shop</p>
              <div className="space-y-2.5">
                <Link to="/women" className="block text-sm text-white/60 hover:text-white transition-colors">Women</Link>
                <Link to="/men" className="block text-sm text-white/60 hover:text-white transition-colors">Men</Link>
                <Link to="/new-arrivals" className="block text-sm text-white/60 hover:text-white transition-colors">New Arrivals</Link>
                <Link to="/collections" className="block text-sm text-white/60 hover:text-white transition-colors">Collections</Link>
              </div>
            </div>

            {/* Customer Care */}
            <div>
              <p className="text-overline text-white/40 mb-4">Customer Care</p>
              <div className="space-y-2.5">
                <Link to="/contact-us" className="block text-sm text-white/60 hover:text-white transition-colors">Contact Us</Link>
                <Link to="/faq" className="block text-sm text-white/60 hover:text-white transition-colors">FAQ</Link>
                <Link to="/shipping-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Shipping Policy</Link>
                <Link to="/return-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Return Policy</Link>
                <Link to="/refund-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Refund Policy</Link>
                <Link to="/cancellation-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Cancellation Policy</Link>
                <Link to="/size-guide" className="block text-sm text-white/60 hover:text-white transition-colors">Size Guide</Link>
              </div>
            </div>

            {/* Legal */}
            <div>
              <p className="text-overline text-white/40 mb-4">Legal</p>
              <div className="space-y-2.5">
                <Link to="/privacy-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Privacy Policy</Link>
                <Link to="/terms-and-conditions" className="block text-sm text-white/60 hover:text-white transition-colors">Terms and Conditions</Link>
                <Link to="/cookie-policy" className="block text-sm text-white/60 hover:text-white transition-colors">Cookie Policy</Link>
                <Link to="/accessibility" className="block text-sm text-white/60 hover:text-white transition-colors">Accessibility</Link>
                <Link to="/payment-information" className="block text-sm text-white/60 hover:text-white transition-colors">Payment Information</Link>
              </div>
            </div>

            {/* About */}
            <div>
              <p className="text-overline text-white/40 mb-4">About</p>
              <div className="space-y-2.5">
                <Link to="/about-us" className="block text-sm text-white/60 hover:text-white transition-colors">About Us</Link>
              </div>
            </div>

            {/* Business Information */}
            <div className="col-span-2 lg:col-span-1">
              <p className="text-overline text-white/40 mb-4">Business Information</p>
              <div className="space-y-1 text-sm text-white/60">
                <p className="font-medium text-white mb-1">Farniymart</p>
                <p>Legal Name: Ankit Giri</p>
                <p className="mt-2">
                  Sumerganj Mandi,<br/>
                  Station Road,<br/>
                  Farniymart,<br/>
                  Bundi, Rajasthan, 323614,<br/>
                  India
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-fashion-border-dark px-4 md:px-8 py-5">
        <div className="fashion-container flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-white/30 tracking-wide">
          <p>© {new Date().getFullYear()} Farniymart. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="hover:text-white/60 transition-colors">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white/60 transition-colors">Terms and Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
